import { Wysiwyg, WysiwygProps } from "@/shared/form/wysiwyg";
import { useWysiwygMention } from "../utils/use-wysiwyg-mention";
import { twMerge } from "tailwind-merge";

export function WysiwygWithPersonMention({
  className,
  ...props
}: WysiwygProps) {
  const mention = useWysiwygMention();

  return (
    <Wysiwyg
      className={twMerge(
        "[&_.rdw-suggestion-dropdown]:whitespace-nowrap",
        className,
      )}
      mention={mention}
      {...props}
    />
  );
}
